import machineDefaultImage from '../../../../images/machineImageEmpty.svg';
import { typedDocumentsImageUrl } from '../../../../utils/imageProxy';
import { useHasPermission } from '../../../../hooks/useHasPermission';
import { ModifierRisque } from '../../editMachine/modifierRisque';
import { Box, Typography, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import Iconify from '../../../Iconify';
import '../../../../css/machines/localisationEtStatut.css';

const RiskBox = ({ image, title }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: "column", gap: "3px", mb: 2 }}>
            <img src={image} alt="icon" style={{ width: '45px', height: '45px', borderRadius: '2px', objectFit: "cover" }} loading='lazy' decoding='async' />
            <Typography className='modeEtConseigne_text_response'>{title}</Typography>
        </Box>
    );
};

const Risk = () => {

    const machineDetailsData = useSelector((state) => state.MachineDetailsData);
    const hasMachineUpdatePermission = useHasPermission('machine_update');

    const [modifyRisk, setModifyRisk] = useState(false);

    return (
        <Box className='localisationEtStatut_box'>
            <Box className='localisation_edit_box'>
                <Typography className='localisationEtStatut_title'>Risques</Typography>
                {hasMachineUpdatePermission && !machineDetailsData?.is_archived && <Iconify className='localisationEtStatut_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyRisk(true)} />}
            </Box>
            <Box className='localisationEtStatut_icon_title_response_box'>
                {machineDetailsData?.risk_machine?.length > 0 ? (
                    <Grid container spacing={4}>
                        {machineDetailsData?.risk_machine?.map((r) => {
                            const img = typedDocumentsImageUrl(r?.risk?.risk_document, { size: 'picto', fallback: machineDefaultImage });
                            return (
                                <Grid key={r?.id} item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <RiskBox
                                        image={img}
                                        title={r?.risk?.name}
                                    />
                                </Grid>
                            );
                        })}
                    </Grid>)
                    :
                    <Typography className='modeEtConsigne_dashed_typography' sx={{ width: '100%' }}>Il n’existe aucun contenu dans cette section</Typography>
                }
            </Box>

            {modifyRisk &&
                <ModifierRisque
                    modifyRisk={modifyRisk}
                    setModifyRisk={setModifyRisk}
                />
            }
        </Box>
    )
}

export default Risk
